var map = {
	"./15mg-mektovi.png": "bf43",
	"./50mg-braftovi.png": "735c",
	"./75mg-braftovi.png": "703a",
	"./arrow-blue.svg": "658b",
	"./arrow-green.svg": "429d",
	"./arrow-magenta.svg": "edc3",
	"./body-desktop.svg": "b97d",
	"./bowel-cancer-uk.png": "8406",
	"./cruk-logo.png": "1503",
	"./encorafenib.svg": "253f",
	"./flag-ireland.png": "94e3",
	"./flag-uk.png": "9fe8",
	"./how-to-take-your-treatment.png": "3664",
	"./img-example.png": "69f9",
	"./irish-cancer-society.png": "ce66",
	"./link-arrow.svg": "2814",
	"./logo-small.svg": "3e11",
	"./logo.svg": "e347",
	"./macmillan-cancer-support.png": "ce0f",
	"./marie-curie-logo.svg": "45ed",
	"./marie-keating-logo.png": "3c90",
	"./melanoma-uk-logo.png": "cb1e",
	"./nerlynx-pack.png": "3155",
	"./nerlynx-tablets.png": "8043",
	"./placeholder-logo.png": "2406",
	"./resource-bg-blue.png": "6f0c",
	"./resource-bg-green.png": "fc26",
	"./resource-bg-magenta.png": "39c2",
	"./treatment-diagram-enc-bini.png": "b00c",
	"./treatment-pills.svg": "056f",
	"./treatment-triangle-dark-mobile.svg": "baad",
	"./treatment-triangle-dark.svg": "fe0d",
	"./treatment-triangle-light-mobile.svg": "584b",
	"./treatment-triangle-light.svg": "be15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";